"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toKeyFigureSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toKeyFigurePicture = function (data) {
    switch (data) {
        case 'Icône Environnement':
            return types_1.KeyFigurePicture.ARROWLEAF;
        case 'Icône Société':
            return types_1.KeyFigurePicture.ARROWUSER;
    }
};
var toKeyFigureSlice = function (data, logger) {
    var picture = logger.required(toKeyFigurePicture(data.primary.picture));
    var number = logger.required(fields_1.toText(data.primary.number));
    var stat = logger.required(fields_1.toText(data.primary.stat));
    var subtitle = logger.required(fields_1.toText(data.primary.subtitle));
    // Test des champs obligatoires
    if (!(picture && number && stat && subtitle)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.KeyFigure)), { picture: picture,
        number: number,
        stat: stat,
        subtitle: subtitle, description: fields_1.toText(data.primary.description) }));
};
exports.toKeyFigureSlice = toKeyFigureSlice;
//# sourceMappingURL=key-figure-slice.js.map